module.exports = __webpack_public_path__ + "img/settle.7bf32148.png";